export default "__VITE_ASSET__71c50d10__"